module.exports = __webpack_public_path__ + "media/images/what_can_do_0-3c3d86b4dcfc655106387b5cbf103ba4.svg";